import { Component, EventEmitter, Input,  Output } from '@angular/core';
import { SectionsChangesEvent } from '../../core/classes/sections-changes-event';
import { EventPoolService } from '../../core/event-pool.service';
import { EntityType } from '../../rl-common/shared/shared/entity-type.enum';
import { Mode } from '../../rl-common/shared/shared/types/mode';
import { Assignment } from '../shared/assignment';

@Component({
  selector: 'rl-assignments-list',
  templateUrl: './assignments-list.component.html',
  styleUrls: ['./assignments-list.component.scss']
})
export class AssignmentsListComponent{

  @Input() assignments : Assignment[];
  @Input() mode : Mode;

  @Output() onSelectChange = new EventEmitter<number | number[]>();

  selectedAsgmtId : number;
  selectedAsgmtIds : number[] = [];

  // sortConfig : SortableOptions = {
  //   onUpdate : (e : any) => {
  //     //since sortablejs already updated the 'sections' list in that point, we need to send the new index twice
  //     this.updateOrder(e.newIndex, e.newIndex);
  //   }
  // }

  constructor(private eventPool : EventPoolService) { }

  removeAssignment(i : number){
    this.eventPool.update(new SectionsChangesEvent('DELETE', EntityType.ASSIGNMENT, this.assignments[i]));
    this.assignments.splice(i, 1);
  }

  handleMultiSelect(a : any){
    if(a.selected) this.selectedAsgmtIds.push(a.id);
    else this.selectedAsgmtIds.splice(this.selectedAsgmtIds.indexOf(a.id),1);

    this.onSelectChange.emit(this.selectedAsgmtIds);
  }

}
